import Splide from "@splidejs/splide";
import { Video } from '@splidejs/splide-extension-video';
window.Splide = Splide;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;

Splide.defaults = {
    perPage: 1,
    mediaQuery: "min",
    pauseOnFocus: false,
    pauseOnHover: false,
    autoplay: true,
};

const sliders = {
    product: {}
};

if (document.querySelector('.suggest-slider')) {
    sliders.suggestSlider = new Splide('.suggest-slider', {

    });

    sliders.suggestSlider.mount();
}

if (document.querySelector('.section-heroslider')) {
    sliders.heroSlider = new Splide('.section-heroslider', {
        autoplay: false,
        fixedHeight: '100vh',
        type: 'fade',
        rewind: true,
        interval: 5000,
        speed: 1000,
        pagination: false,
        arrows: false,
        arrowPath: 'M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z'
    });

    sliders.heroSlider.on( 'autoplay:playing', ( rate ) => {
        let progress = rate * 100;
        
        document.querySelector('.section-heroslider').style.setProperty('--progress', `${progress}%`);
    });

    sliders.heroSlider.mount();
}

if (document.querySelector('.section-desc')) {
    let fan = document.querySelector('.fan img');

    

    window.activateBlade = (bladeNumber) => {
        let text = [
            'Change<br>the<br>game',
            'New<br>thermicool<br>tech',
            'Super<br>fast<br>motor',
        ];

        let textEl = document.querySelector(`.text-wrapper .text${bladeNumber}`);
        // textEl.innerHTML = text[bladeNumber - 1];
        document.querySelectorAll('.text-wrapper .text').forEach(text => {
            if (text.classList.contains('active')) {
                text.classList.remove('active');
            }
        });

        textEl.classList.add('active');
    };

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.section-desc .fan',
            // markers: true,
            start: 'top top',
            pin: '.section-desc',
            pinnedContainer: '.section-desc',
            scrub: 1,
            onUpdate: self => {
                let progress = self.progress * 100;

                // console.log(gsap.getProperty(fan, 'rotation'));

                if (progress >= 0 && progress < 40) {
                    // 0-33%
                    activateBlade(1);
                }
                else if (progress >= 40 && progress < 75) {
                    // 33-66%
                    activateBlade(2);
                }
                else if (progress >= 75 && progress < 100) {
                    // 50-75%
                    activateBlade(3);
                }
                else {
                    return;
                }
            }
        }
    });

    tl.fromTo(
        fan,
        { rotate: 0 },
        { rotate: '-=270', ease: 'linear' },
    );
}

// if (document.querySelector('.home-page .section-video')) {
//     let video = document.querySelector('.section-video .video-wrapper');

//     let tl = gsap.timeline({
//         scrollTrigger: {
//             trigger: video,
//             markers: true,
//             start: 'top center',
//             end: '+=80% center',
//             // pin: '.fan-trigger',
//             // pinnedContainer: '.section-video',
//             scrub: 0.5,
//             // end: (el) => {
//             //     console.log(el);
//             // },
//             // onLeave: () => {
//             //     video.querySelector('video').play();
//             // }
//         }
//     });

//     tl.to(video, { width: '100%' });
// }

// if (document.querySelector('.home-page .section-tm')) {
//     let trigger = document.querySelector('.tm-wrapper');

//     let tl = gsap.timeline({
//         scrollTrigger: {
//             trigger: trigger,
//             markers: true,
//             start: 'top center',
//             end: '+=100% center',
//             pin: trigger,
//             pinnedContainer: '.section-tm',
//             scrub: 0.5,
//             snap: .5,
//             // end: (el) => {
//             //     console.log(el);
//             // },
//             // onLeave: () => {
//             //     video.querySelector('video').play();
//             // }
//         }
//     });

//     tl.fromTo(
//         trigger,
//         { rotate: 90 },
//         { rotate: 270 }
//     );
// }

if (document.querySelector('.mnav-toggle')) {
    let topmenu = document.querySelector('.topmenu');
    let mnav = document.querySelector('.mnav');
    let toggle = document.querySelector('.mnav-toggle');

    mnav.innerHTML = topmenu.outerHTML;

    let mnavTopmenu = document.querySelector('.mnav .topmenu');

    mnavTopmenu.querySelectorAll(':scope > li > a').forEach(item => {
        if (! item.classList.contains('sign-in') && item.nextElementSibling) {
            let text = item.innerHTML;
            let btn = `<button type="button" class="btn btn-toggle"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" /></svg></button>`;

            item.innerHTML = `<span>${text}</span>${btn}`;
        }
    });

    mnavTopmenu.querySelectorAll(':scope > li > a .btn-toggle').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.target.closest('a').classList.toggle('active');
        });
    });

    toggle.addEventListener('click', () => {
        mnav.classList.toggle('active');
    });
}

if (document.querySelector('.footer span.year')) {
    document.querySelector('span.year').textContent = new Date().getFullYear();
}

function stickyHeader() {
    let header = document.querySelector('header');

    const offset = header.offsetHeight;

    if (document.body.scrollTop > offset || document.documentElement.scrollTop > offset) {
        header.classList.add('is-sticky');
    }
    else {
        header.classList.remove('is-sticky');
    }
}

let lastPosY = window.scrollY;

window.addEventListener('scroll', (e) => {
    let curPosY = window.scrollY;
    let header = document.querySelector('header');

    if (curPosY >= lastPosY) {
        // Scrolling down
        header.classList.remove('is-sticky');
        header.classList.add('is-scrolling');
    }
    else {
        // Scrolling Up
        stickyHeader();

        if (curPosY == 0) {
            header.classList.remove('is-scrolling');
        }
    }

    lastPosY = curPosY;
});

if (document.querySelector('.tm-slides')) {
    let slides = document.querySelectorAll('.tm-slide');

    const delay = 2000;

    let tmContent = document.querySelector('.tm-content');
    let tmBody = tmContent.querySelector('.tm-body');
    let tmName = tmContent.querySelector('.tm-name');
    let tmDesig = tmContent.querySelector('.tm-desig');

    slides[0].classList.add('active');

    let interval = setInterval(() => {
        // clearInterval(interval);

        let active;

        slides.forEach(slide => {
            if (slide.classList.contains('active')) {
                active = slide;

                slide.classList.remove('active');
            }
        });

        if (active.nextElementSibling != null) {
            // active.classList.remove('active');
            active.nextElementSibling.classList.add('active');
            active = active.nextElementSibling;
        }
        else {
            active = slides[0];
            active.classList.add('active');
        }

        let tmSlideText = active.querySelector('.tm-slide-text');
        tmBody.innerHTML = tmSlideText.innerHTML;
        tmName.innerHTML = tmSlideText.dataset.name;
        tmDesig.innerHTML = tmSlideText.dataset.desig;

        // if (active == 0) {
        //     active++;
        // }

        // if (active == slides.length - 1) {
        //     active = 0;
        // }

        // slides[active].classList.add('active');

        // debugger;

    }, delay);
}

import Tab from 'bootstrap/js/dist/tab';

import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import localeEn from 'air-datepicker/locale/en';

window.dayjs = require('dayjs');
const customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);

const dpInit = (field, type) => {
    let format = field.dataset.datepickerFormat || 'yyyy-MM-dd';
    let timeFormat = field.dataset.timepickerFormat || 'HH:mm';

    if (type == 'date') {
        let dp = new AirDatepicker(field, {
            locale: localeEn,
            dateFormat: format,
            selectedDates: [
                dayjs(field.value, field.dataset.dayjsFormat).format()
            ]
        });
    }

    if (type == 'time') {
        console.log(field.value);

        let dtp = new AirDatepicker(field, {
            locale: localeEn,
            dateFormat: format,
            timepicker: true,
            timeFormat: timeFormat,
            selectedDates: [
                dayjs(field.value, field.dataset.dayjsFormat).format()
            ]
        });
    }
};

if (document.querySelector('.datepicker-field')) {
    let fields = document.querySelectorAll('.datepicker-field');

    fields.forEach(field => {
        dpInit(field, 'date');
    });
}

if (document.querySelector('.datetimepicker-field')) {
    let fields = document.querySelectorAll('.datetimepicker-field');

    fields.forEach(field => {
        dpInit(field, 'time');
    });
}

if (document.querySelector('[data-setbg]')) {
    let elems = document.querySelectorAll('[data-setbg]');
    elems.forEach(elem => {
        elem.style.backgroundImage = `url(${elem.dataset.setbg})`;
    });
}

if (document.querySelector('.accordion')) {
    window.accordionInit = () => {
        let aHead = document.querySelectorAll('.accordion-head');
        aHead.forEach(el => {
            el.addEventListener('click', (e) => {
                let state = false;

                state = (el.classList.contains('shown')) ? true : false;

                let isolated = el.closest('.accordion').classList.contains('accordion-isolate');

                if (! isolated) {
                    if (document.querySelector('.accordion-item.expanded')) {
                        document.querySelector('.accordion-item.expanded').classList.remove('expanded');
                    }
    
                    if (document.querySelector('.accordion-head.shown')) {
                        document.querySelector('.accordion-head.shown').classList.remove('shown');
                    }
                }

                if (el.classList.contains('shown')) {
                    el.classList.toggle('shown');
                    el.closest('.accordion-item').classList.remove('expanded');
                }

                if (!el.classList.contains('shown')) {
                    el.classList.toggle('shown');
                    el.closest('.accordion-item').classList.add('expanded');
                }

                if (state) {
                    el.classList.remove('shown');
                    el.closest('.accordion-item').classList.remove('expanded');
                }
            });
        });
    };

    accordionInit();
}

import MiniMasonry from "minimasonry";
window.MiniMasonry = MiniMasonry;

if (document.querySelector('.dcard__container')) {
    window.dcard = new MiniMasonry({
        container: '.dcard__container',
        baseWidth: 350,
        gutter: 30,
        minify: false,
        // wedge: true
        ultimateGutter: 30
    });
}

if (document.querySelector('.section-infographic')) {
    sliders.discoverSlider = new Splide('.section-infographic .discover-slider', {
        autoplay: true,
        focus: 'center',
        type: 'loop',
        interval: 7000,
        pagination: true,
        arrows: false,
        // autoWidth: true,
        // fixedWidth: '75vw',
        easing: 'cubic-bezier(.4,0,.2,1)',
        // heightRatio: 0.5625,
        autoHeight: true,
        // cover: true,
        gap: 30
    });

    sliders.discoverSlider.mount();
}

if (document.querySelector('.section-tm2 .tm-slider')) {
    sliders.tmSlider = new Splide('.section-tm2 .tm-slider', {
        autoplay: false,
        focus: 'center',
        type: 'loop',
        interval: 3000,
        // pagination: false,
        arrows: false,
        // autoWidth: true,
        fixedWidth: '75vw',
        easing: 'cubic-bezier(.4,0,.2,1)',
        // heightRatio: 0.5625,
        fixedHeight: '70vh',
        cover: true,
        video: {
            loop: true,
        }
    });

    sliders.tmSlider.mount({ Video });
}

if (document.querySelector('.product-single .meta-btn')) {
    let btns = document.querySelectorAll('.product-single .meta-btn');

    btns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            let items = e.target.closest('.meta-items');

            if (items.querySelector('.meta-btn.active')) {
                items.querySelector('.meta-btn.active').classList.remove('active');
            }

            e.target.closest('.meta-btn').classList.add('active');
        });
    });
}

if (document.querySelector('.product-single .meta-pin')) {
    let btn = document.querySelector('.product-single .meta-pin button');

    let delivery = document.querySelector('.product-single .meta-delivery');

    btn.addEventListener('click', () => {
        delivery.classList.add('success');
        delivery.querySelector('span').innerHTML = `Expected delivery by: Sep 27 - Oct 3`;
    });
}

if (document.querySelector('.product-single-page .product-single')) {
    sliders.product.gallerySlider = new Splide('.product-single .gallery-slider', {
        autoplay: true,
        arrows: false,
        pagination: false,
        fixedHeight: 'calc(100vh - 60px - var(--header-h))'
    });

    sliders.product.galleryThumbSlider = new Splide('.product-single .gallery-thumb-slider', {
        autoplay: true,
        arrows: false,
        pagination: false,
        fixedHeight: 80,
        fixedWidth: 80,
        gap: 20,
        isNavigation: true,
    });

    sliders.product.gallerySlider.sync(sliders.product.galleryThumbSlider);
    sliders.product.gallerySlider.mount();
    sliders.product.galleryThumbSlider.mount();
}

if (document.querySelector('.product-single-page .product-single .offer-slider')) {
    sliders.product.offerSlider = new Splide('.product-single .offer-slider', {
        autoplay: false,
        // arrows: false,
        pagination: false,
        perPage: 2,
        gap: 15,
    });

    sliders.product.offerSlider.mount();
}

if (document.querySelector('.product-single-page .product-single .offer-slider-2')) {
    sliders.product.offerSliderTwo = new Splide('.product-single .offer-slider-2', {
        autoplay: false,
        // arrows: false,
        pagination: false,
        perPage: 2,
        gap: 15,
    });

    sliders.product.offerSliderTwo.mount();
}

import noUiSlider from 'nouislider';

if (document.querySelector('.product-listing-page')) {
    if (document.querySelector('.price-range')) {
        let range = document.querySelector('.price-range');

        noUiSlider.create(range, {
            start: [0, 10000],
            range: {
                min: [0],
                max: [10000],
            }
        });
    }

    if (document.querySelector('.pcard__colors')) {
        let colors = document.querySelectorAll('.pcard__colors .color');

        colors.forEach(color => {
            color.addEventListener('click', (e) => {
                e.preventDefault();

                let items = e.target.closest('.pcard__colors');

                if (items.querySelector('.color.active')) {
                    items.querySelector('.color.active').classList.remove('active');
                }

                e.target.classList.add('active');

                let index = e.target.dataset.img;

                let imgs = e.target.closest('.pcard').querySelectorAll('.pcard__img img');

                imgs.forEach(img => {
                    if (img.classList.contains('active')) {
                        img.classList.remove('active');
                    }
                });

                imgs[index].classList.add('active');
            });
        });
    }

    if (document.querySelector('.pcard__meta')) {
        let btns = document.querySelectorAll('.pcard__meta-btn');

        btns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();

                let items = e.target.closest('.pcard__meta-wrap');

                if (items.querySelector('.pcard__meta-btn.active')) {
                    items.querySelector('.pcard__meta-btn.active').classList.remove('active');
                }

                e.target.closest('.pcard__meta-btn').classList.add('active');
            });
        });
    }
}

import counterUp from 'counterup2';
window.counterUp = counterUp;

if (document.querySelector('.counter')) {
    const callback = entries => {
        entries.forEach(entry => {
            const el = entry.target;

            if (entry.isIntersecting) {
                counterUp( el, {
                    duration: 2000,
                    delay: 16,
                } );
            }
        });
    };
    
    const IO = new IntersectionObserver( callback, { threshold: 1 } );
    
    const elems = document.querySelectorAll( '.counter' );
    elems.forEach(el => {
        IO.observe( el );
    });
}

window.fslightbox = require('fslightbox');

window.sliders = sliders;